"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ActorCard = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "4 4 24 24",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.581 4c1.285 0 1.97.132 2.684.514a3.757 3.757 0 011.555 1.555c.35.654.49 1.284.51 2.374l.003.309v5.915h-2.668v-4H6.667l.001 10.14.013.408c.024.407.08.598.184.792.108.202.26.353.461.461.094.05.187.09.303.119l.126.026.248.031.073.006.078.004.372.011h6.14v2.668H8.753c-1.285 0-1.97-.132-2.683-.513a3.757 3.757 0 01-1.555-1.555c-.35-.654-.49-1.284-.511-2.374L4 20.58V8.751c0-1.284.132-1.969.514-2.682a3.756 3.756 0 011.555-1.555c.654-.35 1.284-.49 2.374-.511L8.752 4h11.83zM8 5.333A1.333 1.333 0 108 8a1.333 1.333 0 000-2.667zm14.667 21.334a4 4 0 100-8 4 4 0 000 8zm0 1.333a5.333 5.333 0 100-10.667 5.333 5.333 0 000 10.667zm0-2.667a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333z",
  fill: "#1973E8",
  className: "fill"
}));
var _default = exports.default = ActorCard;